export const TRIMS_VALUE = '3';